import axiosInstance from '../../services/axiosInstance';
import { useContext, useState } from 'react';
import UserContext from '../../context/userContext';
import { useNavigate, useParams } from 'react-router';
import { Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, useDisclosure } from '@chakra-ui/react';
import getProfilePic from '../../helpers/getProfilePic';
import { ModalContrasena } from './ModalContrasena';
import { useTranslation } from 'react-i18next';

const Login = () => {

  const { t } = useTranslation();

  const [loginData, setLoginData] = useState({ correo: '', contrasena: '' });
  const [error, setError] = useState({ error: false, msg: '' });

  // eslint-disable-next-line no-unused-vars
  const { setUser } = useContext(UserContext);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleLogin = async () => {
    setIsLoading(true);
    try {
      const user = await axiosInstance.post(
        `${process.env.REACT_APP_BASE_URL}/login`,
        loginData,
        { withCredentials: true }
      );

      if (user.data.usuario) {
        const profilePic = await getProfilePic(user.data.usuario.id);
        setUser({
          ...user.data.usuario,
          foto: profilePic || '',
          precioActual:
            user.data.usuario.rol === 'TITULAR'
              ? user.data.usuario.datosMembresia.precioActual
              : null,
        });

        return navigate('/');
      } else {
        setError({ error: true, msg: t('LOGIN_ERROR') });
      }
    } catch (err) {
      if (err.response) {
        setError({
          ...error,
          error: true,
          msg: err.response.data.error,
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="d-flex flex-row vh-100 bg-dark justify-content-center align-items-center">
      <ModalContrasena
        isOpen={isOpen}
        onClose={onClose}
      />
      <div className="d-flex text-light flex-column justify-content-between align-items-center">
        <header>
          <img
            alt="Campina logo"
            className="logo py-2"
            src="/assets/Logo-sin-fondo-blanco.png"
            width="250"
            height="250"
          />
        </header>

        <input
          type="email"
          className="form-control my-2"
          value={loginData.correo}
          placeholder={t('EMAIL')}
          onChange={(e) => {
            e.preventDefault();
            setLoginData({
              ...loginData,
              correo: e.target.value,
            });
          }}
        />
        <input
          type="password"
          className="my-2 form-control"
          value={loginData.contrasena}
          placeholder={t('PASSWORD')}
          onChange={(e) => {
            e.preventDefault();
            setLoginData({
              ...loginData,
              contrasena: e.target.value,
            });
          }}
        />
        {error.error ? (
          <div className="text-danger">Error: {error.msg}</div>
        ) : null}
        <br />
        <Button
          my="5"
          colorScheme="yellow"
          onClick={handleLogin}
          disabled={isLoading}
          opacity={isLoading ? 0.5 : 1}
          isLoading={isLoading}
          loadingText={t('LOGGING_IN')}
          style={{ cursor: isLoading ? 'not-allowed' : 'pointer' }}
        >
          {t('LOGIN')}
        </Button>
        <br />
        <span
          className="mt-3"
          onClick={onOpen}
          style={{ cursor: 'pointer' }}
        >
          <b>{t('FORGOT_PASSWORD')}</b>{' '}
        </span>
        <span className="pt-3">v{process.env.REACT_APP_VERSION}</span>
      </div>
    </div>
  );
};

export default Login;
